import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class PairingService {

    private host: any = {};

    constructor(private client: HttpClient) {
        this.host['v2-pairing'] = environment.host('v2-pairing');
        this.host['v1-pairing'] = environment.host('v1-pairing');
    }

    searchDevices(serialNumber: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-pairing']}/v2/pairing/admin/devices`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            params: { sn: serialNumber }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('PairingService.searchDevices.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('PairingService.searchDevices.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getAllDevicesByAccountIdV2(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-pairing']}/v2/pairing/admin/${accountId}/devices`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('PairingService.getAllDevicesByAccountIdV2.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('PairingService.getAllDevicesByAccountIdV2.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2FirmwaresByDevice(accountId: string, serialNumber: string) {
        return this.client.request('GET', `${this.host['v2-pairing']}/v2/pairing/admin/${accountId}/devices/${serialNumber}/firmwares`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('PairingService.getV2FirmwaresByDevice.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('PairingService.getV2FirmwaresByDevice.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getAllDevicesByAccountId(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-pairing']}/v1/pairing/all`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('PairingService.getAllDevicesByAccountId.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('PairingService.getAllDevicesByAccountId.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getAllApplicationsByAccountId(accountId: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-pairing']}/v1/pairing/all/app`, {
            headers: { 'X-MyKronoz-Authorization': `account=${accountId}` },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('PairingService.getAllApplicationsByAccountId.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('PairingService.getAllApplicationsByAccountId.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }
}
